import {
  File,
  FileImage,
  FileText,
  FileCode,
  Link as LinkIcon,
} from 'lucide-react';
import { Document } from '../../lib/api';
import { CATEGORY_COLOR_MAP, FILE_EXTENSIONS } from './constants';

export function getFileIcon(doc: Document) {
  if (doc.document_type === 'url') {
    return <LinkIcon className="h-5 w-5" />;
  }

  const ext = doc.file_extension?.toLowerCase();

  if (FILE_EXTENSIONS.image.includes(ext || '')) {
    return <FileImage className="h-5 w-5" />;
  }
  if (FILE_EXTENSIONS.pdf.includes(ext || '')) {
    return <File className="h-5 w-5 text-red-500" />;
  }
  if (FILE_EXTENSIONS.spreadsheet.includes(ext || '')) {
    return <File className="h-5 w-5 text-green-500" />;
  }
  if (FILE_EXTENSIONS.archive.includes(ext || '')) {
    return <File className="h-5 w-5 text-yellow-500" />;
  }
  if (FILE_EXTENSIONS.code.includes(ext || '')) {
    return <FileCode className="h-5 w-5" />;
  }

  return <FileText className="h-5 w-5" />;
}

export function getCategoryColor(color: string): string {
  return CATEGORY_COLOR_MAP[color] || CATEGORY_COLOR_MAP['gray'];
}
